import {
  Feature,
  FeatureCategory,
  FeatureSummary,
} from "@/lib/types/features.ts";
import * as S from "./styles.ts";
import { Accordion2, UniversalLink } from "@template/components";

interface IFeaturesSideMenuProps {
  categories: FeatureCategory[];
  featureList: FeatureSummary[];
  activeCategoryId: number;
}

const formatTitle = (title: string) =>
  title.replace("Business Phone Systems - ", "").replace(/<\/?[^>]+(>|$)/g, "");

const renderLinks = (
  featureList: FeatureSummary[],
  category: FeatureCategory,
) => {
  const currentCategoryFeatures = featureList?.filter(
    (feature) => feature.category_id === category.id,
  );
  return currentCategoryFeatures.map((feature) => (
    <UniversalLink
      title={`Learn About ${formatTitle(feature.title)} ${category.category_name} Feature`}
      key={feature.id}
      href={`/${feature.direct_url}`}
      scroll={false}
    >
      {formatTitle(feature.title)}
    </UniversalLink>
  ));
};

const formatCategories = (
  categories: FeatureCategory[],
  featureList: Feature[],
) => {
  return categories.map((category) => {
    return {
      title: category.category_name,
      content: (
        <S.SideMenuLinksContainer>
          {renderLinks(featureList, category)}
        </S.SideMenuLinksContainer>
      ),
    };
  });
};

export const FeaturesSideMenu = ({
                                   categories,
                                   featureList,
                                   activeCategoryId,
                                 }: IFeaturesSideMenuProps) => {
  const activeCategory = categories.findIndex(
    (category) => category.id === activeCategoryId,
  );
  const defaultActive =
    activeCategory > -1 && activeCategory < categories.length
      ? activeCategory
      : undefined;
  const items = formatCategories(categories, featureList);
  return (
    <S.FeaturesSideMenuContainer>
      <Accordion2
        items={items}
        withArrow={false}
        defaultActiveIndex={defaultActive}
      />
    </S.FeaturesSideMenuContainer>
  );
};
